import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    ispay: 0,
    ischeck: 0,
    ismanager: 0,
    supermanager: 0,
    accountName: '',
    plat: 1,
  },
  mutations: {
    setIscheck(state, ischeck) {
      state.ischeck = ischeck;
    },
    getIscheck() {
      return state.ischeck;
    },
    setIspay(state, ispay) {
      state.ispay = ispay;
    },
    getIspay() {
      return state.ispay;
    },
    setSupermanager(state, supermanager) {
      state.supermanager = supermanager;
    },
    getSupermanager() {
      return state.supermanager;
    },
    setIsmanager(state, ismanager) {
      state.ismanager = ismanager;
    },
    getIsmanager() {
      return state.ismanager;
    },
    setAccountName(state, accountName) {
      state.accountName = accountName;
    },
    getAccountName() {
      return state.accountName;
    },
    setPlat(state, plat) {
      state.plat = plat;
    },
    getPlat() {
      return state.plat;
    },
  },
  getters: {
    ismanager(state) {
      return state.ismanager;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js